<template>
	<div>
		<div class="title" @click="toggleForm">Non trovi il tuo Allestimento?</div>
		<form class="form-contact" :class="{ 'd-none': !isFormVisible }" action="/api/find-setup" method="POST"
			@submit="handleSubmit" ref="contactForm">
			<div class="text-align-right close-form" @click="toggleForm">
				<img src="../../../images/project-img/close.svg" width="14" alt="" />
			</div>
			<div class="label">
				<label>
					Indicaci l’Allestimento della tua auto e verrai contattato dal nostro Servizio Clienti.
				</label>
				<p class="text-secondary" v-if="!isLogged">
					Per inviare il messaggio devi effettuare la Registrazione o il Login
				</p>
			</div>
			<template v-if="isLogged">
				<div class="form-group">
					<!-- Possiamo ricevere nome e cognome? -->
					<div class="input-group">
						<label for="contact_name">Nome</label>
						<input type="text" name="contact_name" id="contact_name" placeholder="Nome" v-model.trim="name" required />
					</div>
					<div class="input-group">
						<label for="contact_surname">Cognome</label>
						<input type="text" name="contact_surname" id="contact_surname" placeholder="Cognome" v-model.trim="surname"
							required />
					</div>
					<div class="input-group">
						<label for="contact_email">Email</label>
						<input type="email" name="contact_email" id="contact_email" placeholder="Email" v-model.trim="email"
							required />
					</div>

					<!-- VERIFICA EMAIL -->
					<div class="input-group">
						<label :for="'verify_email'" :class="{
							'text-secondary': showValidation && emailMismatch,
							'text-green': showValidation && emailMatch,
						}">
							{{ showValidation && emailMismatch ? 'La mail non corrisponde' : 'Verifica Email' }}
						</label>
						<input type="email" name="verify_email" id="verify_email" placeholder="Verifica Email"
							v-model.trim="verifyEmail" @paste.prevent @blur="onVerifyBlur" required />
					</div>
					<div class="input-group">
						<label for="contact_phone">Targa</label>
						<input type="text" name="plate" id="plate" placeholder="Targa" class="text-transform-uppercase"
							v-model.trim="plate" required maxlength="7" />
					</div>
				</div>
				<label for="contact_textarea" class="label-textarea">Messaggio</label>
				<textarea name="contact_textarea" id="contact_textarea" rows="10"
					placeholder="Descrivi la tua auto e la relativa offerta" maxlength="1000" v-model="contactMessage"></textarea>
				<div class="remaining_characters">{{ remainingCharacters }} rimanenti</div>
				<div class="text-align-right">
					<button :class="['button-primary mt-10', { 'button-disabled': !formValid }]" type="submit"
						:disabled="!formValid">
						<template v-if="!loading">
							<span>Invia</span>
						</template>
						<loader v-else size="20px" />
					</button>
				</div>
			</template>
			<template v-else>
				<div class="text-align-center">
					<button class="button-primary mt-10" @click.prevent="redirectToLogin">
						<span>Login</span>
					</button>
				</div>
			</template>
		</form>
		<sw-alert :show="showAlert" :type="alertType" :title="alertTitle" :text="alertText" @close="resetAlert" />
	</div>
</template>

<script>
import SwAlert from './SwAlert.vue';
import Loader from './Loader.vue';

export default {
	name: 'FindEquipment',
	components: {
		SwAlert,
	},
	props: {
		loggedUser: {
			type: Object,
			required: false,
		},
		quattroruoteUrl: {
			type: String,
			required: true,
		},
		findSetup: {
			type: Object,
			required: true,
		}
	},
	data() {
		return {
			isFormVisible: false,
			name: '',
			surname: '',
			email: this.findSetup.email || '',
			verifyEmail: '',
			plate: this.findSetup.targa || '',
			verifyBlurred: false,
			contactMessage: '',
			maxCharacters: 1000,
			showAlert: false,
			alertType: 'success',
			alertTitle: '',
			alertText: '',
			loading: false,
		};
	},
	computed: {
		isLogged() {
			return !!this.loggedUser;
		},
		remainingCharacters() {
			return this.maxCharacters - this.contactMessage.length;
		},
		showValidation() {
			return this.verifyBlurred;
		},
		emailMismatch() {
			return this.verifyEmail !== this.email;
		},
		emailMatch() {
			return this.verifyEmail !== '' && this.verifyEmail === this.email;
		},
		formValid() {
			return (
				this.name &&
				this.surname &&
				this.email &&
				this.verifyEmail &&
				this.plate &&
				this.contactMessage &&
				this.emailMatch
			);
		},
	},
	methods: {
		toggleForm() {
			this.isFormVisible = !this.isFormVisible;
		},
		onVerifyBlur() {
			this.verifyBlurred = true;
		},
		redirectToLogin() {
			window.location.href = '/auth/domus';
		},
		async handleSubmit(event) {
			event.preventDefault();
			this.loading = true;
			if (!this.formValid) {
				this.showAlert = true;
				this.alertType = 'error';
				this.alertTitle = 'Errore';
				this.alertText = 'Compila tutti i campi correttamente.';
				return;
			}

			const form = this.$refs.contactForm;
			const formData = new FormData(form);

			try {
				const response = await fetch(form.action, {
					method: form.method,
					body: formData,
				});

				this.showAlert = true;

				if (response.ok) {
					this.alertType = 'success';
					this.alertTitle = 'Grazie!';
					this.alertText = 'Verrai contattato a breve dal nostro Servizio Clienti';
				} else {
					this.alertType = 'error';
					this.alertTitle = 'Errore';
					this.alertText = "Errore nell'invio del messaggio";
				}
			} catch (error) {
				this.showAlert = true;
				this.alertType = 'error';
				this.alertTitle = 'Errore';
				this.alertText = "Errore nell'invio del messaggio";
			}

			this.resetForm();
		},
		resetForm() {
			this.name = '';
			this.surname = '';
			this.email = '';
			this.verifyEmail = '';
			this.plate = '';
			this.verifyBlurred = false;
			this.contactMessage = '';
			this.isFormVisible = false;
			this.loading = false;
		},
		resetAlert() {
			this.showAlert = false;
		},
	},
};
</script>

<style scoped>
.form-group {
	margin-bottom: 20px;
	display: flex;
	gap: 24px;
	flex-wrap: wrap;
}

.form-group input {
	background: #ffffff 0% 0% no-repeat padding-box;
	padding: 10px;
	border: 1px solid #b1b1b1;
	border-radius: 4px;
	font: normal normal normal 14px / 19px Montserrat;
	letter-spacing: 0px;
	color: #444;
	outline: none;
}

.form-group input::placeholder {
	color: #b1b1b1;
}

.input-group {
	display: flex;
	flex-direction: column;
	width: 18%;

	@media (max-width: 768px) {
		width: 100%;
	}
}

.input-group label {
	font-size: 13px;
	margin-bottom: 3px;
}

.label-textarea {
	font-size: 13px;
	margin-bottom: 5px;
}

#contact_textarea {
	color: #444;
}

#contact_textarea::placeholder {
	color: #b1b1b1;
}

.text-secondary {
	color: #FF66C4;
}

.text-green {
	color: #218c74;
}

.button-disabled {
	opacity: 0.5;
	cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/FindEquipment.vue